export default __webpack_public_path__ + "static/media/ben1.6145353c.svg";